import Link from 'antd/lib/typography/Link';
import * as React from 'react';
import { formatDateWithTimezone } from '../../timeHelpers';
import Divider from 'antd/lib/divider';
import Text from 'antd/lib/typography/Text';
import Tag from 'antd/lib/tag';
import { runwayColors, tagStyle } from '../styles/globalStyles';
import { dayjs } from '@/extendedDayjs';
import TimeWithConditionalTz from '@/components/common/TimeWithConditionalTz';

const RegressionTestingRunHeader: React.FC<{
    name: string;
    url: string;
    integrationIcon: string;
    integrationIconAlt: string;
    createdAt: Date;
    percentComplete: number;
    completedAt?: Date;
    use24HourTimeFormat: boolean;
    effectiveTimezone: string;
}> = ({
    name,
    url,
    integrationIconAlt,
    integrationIcon,
    completedAt,
    createdAt,
    percentComplete,
    use24HourTimeFormat,
    effectiveTimezone,
}) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                minWidth: 0,
                paddingTop: 8,
                paddingBottom: 8,
            }}
        >
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginRight: 16, minWidth: 0 }}>
                <img src={integrationIcon} alt={integrationIconAlt} width={20} height={20} />
                <Link href={url} target="_blank" strong ellipsis>
                    {name}
                </Link>
                <Text type="secondary" style={{ flexShrink: 0 }}>
                    -{' '}
                    {completedAt ?
                        <>
                            completed{' '}
                            <TimeWithConditionalTz
                                triggeredAtLabel={formatDateWithTimezone(
                                    completedAt,
                                    'short',
                                    effectiveTimezone,
                                    use24HourTimeFormat,
                                )}
                                triggeredByMoment={dayjs(completedAt)}
                                use24HourTimeFormat={use24HourTimeFormat}
                                effectiveTimezone={effectiveTimezone}
                                style={{ color: 'inherit' }}
                            />
                        </>
                    :   <>
                            started{' '}
                            <TimeWithConditionalTz
                                triggeredAtLabel={formatDateWithTimezone(
                                    createdAt,
                                    'short',
                                    effectiveTimezone,
                                    use24HourTimeFormat,
                                )}
                                triggeredByMoment={dayjs(createdAt)}
                                use24HourTimeFormat={use24HourTimeFormat}
                                effectiveTimezone={effectiveTimezone}
                                style={{ color: 'inherit' }}
                            />
                        </>
                    }
                </Text>
                <Divider type="vertical" />
                <Text type="secondary" style={{ flexShrink: 0 }}>
                    {percentComplete}% tested
                </Text>
            </div>
            <Tag
                color={completedAt ? runwayColors.statusGreen : runwayColors.statusYellow}
                style={{ ...tagStyle, fontSize: 10 }}
            >
                {completedAt ? 'TEST RUN COMPLETE' : 'TEST RUN ACTIVE'}
            </Tag>
        </div>
    );
};

export default RegressionTestingRunHeader;
